import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Settings } from 'luxon';

import { useAppConfig } from '@/redux/features/app-config/hooks';

export const LocaleListener: FC = () => {
  const { i18n } = useTranslation();
  const { locale } = useAppConfig();

  useEffect(() => {
    // i18n
    i18n.changeLanguage(locale);
    // Date lib
    Settings.defaultLocale = locale;
  }, [locale]);

  return null;
};
